import apiClient from '../apiClient';
import { GET_COUNTRY_URL } from '../apiUrl';

const getCountryApi = () => {
  return apiClient.get(GET_COUNTRY_URL);
};

export default getCountryApi;
